import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@tempmee/react';
import { fetchMultidayJobs } from '../../actions/multidayActions';
import { createLoadingSelector } from '../../apis/selectors';
import history from '../../history';
import { ListPage, ListPageTotal } from '../commonComponents/ListPage';
import { Table } from '../commonComponents/Table/Table';
import { multidayColumn, multidayJobConditionalRowStyles } from '../commonComponents/jobs-column';

const ROWS_PER_PAGE = 15;

const actions = ['FETCH_MULTIDAY_JOBS'];
const loadingSelector = createLoadingSelector(actions);

export const MultidayList = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => loadingSelector(state));
  const allJobs = useSelector((state) => state.multiday.allJobs);
  const searchParams = useSelector((state) => state.multiday.searchParams);
  const totalJobs = useSelector((state) => state.multiday.totalJobs);
  const totalJobsPostedByMDB = useSelector((state) => state.multiday.totalJobsPostedByMDB);
  const totalPages = Math.ceil(totalJobs / ROWS_PER_PAGE);

  const handleTableChange = (page) => {
    dispatch(fetchMultidayJobs({ page }));
  };

  const getJobUrl = (job) => `/multiday/${job.id}`;

  const getOfficeUrl = (userId, userType) => `/user/${userType.toLowerCase()}/${userId}`;

  const getColumn = () =>
    multidayColumn({
      getJobUrl,
      getOfficeUrl,
    });

  useEffect(() => {
    dispatch(fetchMultidayJobs({ page: searchParams.page ? searchParams.page : 1 }));
  }, [dispatch]);

  return (
    <ListPage
      title="Multi-Day Booking"
      isLoading={isLoading}
      actions={(
        <Button
          variant="outlined"
          color="secondary"
          size="small"
          onClick={() => history.push('/multiday/post')}
        >
          Post Multi-Day
        </Button>
      )}
      meta={(
        <>
          <ListPageTotal value={totalJobs} />
          <ListPageTotal label="Total Jobs" value={totalJobsPostedByMDB} />
        </>
      )}
    >
      <Table
        keyField="multiday.id"
        columns={getColumn()}
        data={allJobs}
        noDataComponent="There are no Jobs"
        isLoading={isLoading}
        totalPages={totalPages}
        showTotal={false}
        paginationPerPage={ROWS_PER_PAGE}
        paginationTotalRows={totalJobs}
        onPageChange={handleTableChange}
        showColumnsToHide={false}
        sortServer={false}
        conditionalRowStyles={multidayJobConditionalRowStyles}
      />
    </ListPage>
  );
};
